import { Injectable } from '@angular/core';

export interface Attribute {
  trait_type: string;
  values: string[];
}

@Injectable({
  providedIn: 'root'
})
export class MasksService {
  items: any[] = [];

  constructor() {
    for (let i = 0; i < 500; i++) {
      this.items[i] = {
        id: i + 1,
        imageurl: `https://arweave.net/0-bFc9sKASAEJGN-EXKkXP0cC3bumJRL4-KHQzGYh9g/${i + 1}.gif`
      }
      this.items[i].id = i + 1;
      this.items[i].image = `https://arweave.net/0-bFc9sKASAEJGN-EXKkXP0cC3bumJRL4-KHQzGYh9g/${i + 1}.gif`;
    }
  }

  get() {
    return this.items;
  }
}